const baseClasses =
  /*tw*/ 'w-full pr-10 rounded-md shadow-sm border border-solid focus:shadow-none focus:ring-1';
const errorClasses =
  /*tw*/ 'border-red-400 text-red-700 placeholder-red-400 focus:border-red-500 focus:ring-red-500';
const validClasses =
  /*tw*/ 'border-gray-400 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:ring-blue-500';

export { baseClasses, errorClasses, validClasses };
